// Angular
import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {NotificationService} from '../../../../../core/auth/_services';
import {AppState} from '../../../../../core/reducers';
import {select, Store} from '@ngrx/store';
import {selectNewNotificationCount, selectNotificationInStore} from '../../../../../core/auth/_selectors/notification.selectors';
import {QueryResultsModel} from '../../../../../core/_base/crud';
import {NotificationModel} from '../../../../../core/auth/_models/notification.model';
import {BehaviorSubject, Observable, of} from 'rxjs';
import {Update} from '@ngrx/entity';
import {NotificationClear, NotificationDeleted, NotificationUpdated} from '../../../../../core/auth/_actions/notificaiton.actions';
import {Router} from '@angular/router';
import { map } from 'rxjs/operators';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { SubdomainService } from 'src/app/core/_base/subdomain.service';

@Component({
    selector: 'kt-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['notification.component.scss']
})
export class NotificationComponent implements OnInit {

    // Show dot on top of the icon
    @Input() dot: string;

    // Show pulse on icon
    @Input() pulse: boolean;

    @Input() pulseLight: boolean;

    // Set icon class name
    @Input() icon = 'flaticon2-bell-alarm-symbol';
    @Input() iconType: '' | 'success';

    // Set true to icon as SVG or false as icon class
    @Input() useSVG: boolean;

    // Set bg image path
    @Input() bgImage: string;

    // Set skin color, default to light
    @Input() skin: 'light' | 'dark' = 'light';

    @Input() type: 'brand' | 'success' = 'success';

    @ViewChild('notifDropdown')
    dropdown!: NgbDropdown


    cnt: Observable<number> = this.store.pipe(select(selectNewNotificationCount));
    pulsing$ = this.cnt.pipe(map(cnt => cnt > 0))
    entitySubject = new BehaviorSubject<any[]>([]);

    /**
     * Component constructor
     *
     * @param sanitizer: DomSanitizer
     * @param service: NotificationService
     */
    constructor(private sanitizer: DomSanitizer,
                private router: Router,
                private service: NotificationService,
                private store: Store<AppState>,
                private subdomainService: SubdomainService
            ) {
    }

    ngOnInit(): void {

        this.store.pipe(select(selectNotificationInStore))
            .subscribe((response: QueryResultsModel) => {
                this.entitySubject.next(response.items
                    .filter(item => item.is_new == 1)
                    .map(item => {
                        return fromUTC(item)
                    }));
            });

        this.cnt = this.store.pipe(select(selectNewNotificationCount));
    }

    goToLink(item: NotificationModel) {
        if (item.is_new) {
            const oldItem = Object.assign({}, item) as NotificationModel;
            oldItem.is_new = false;
            oldItem.created_at = (item.created_at as any).replace('UTC', '')
            const updatedItem: Update<NotificationModel> = {
                id: oldItem.id,
                changes: oldItem
            };

            this.store.dispatch(new NotificationUpdated({
                partialItem: updatedItem,
                item: oldItem
            }));
        }
        if (item.link && item.link.startsWith('https'))
        {
            window.open(item.link, '_blank').focus()
            return
        }
        if (item.link && item.link.length > 0) {
            this.dropdown?.close()
            this.router.navigateByUrl(`/org/${this.subdomainService.subDomain}${item.link}`);
        }

    }

    removeOne(id) {
        this.store.dispatch(new NotificationDeleted({id}));
    }

    removeAll() {
        this.store.dispatch(new NotificationClear());
        this.service.flush().subscribe(res => {
        });
    }


    backGroundStyle(): string {
        if (!this.bgImage) {
            return 'none';
        }

        return 'url(' + this.bgImage + ')';
    }
}

export function fromUTC(item: NotificationModel) {
    return {
        ...item,
        created_at: `${item.created_at} UTC`,
    }
}